/* eslint-disable react-hooks/exhaustive-deps */

import { Box } from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { getAddress, deleteAuthTrip } from 'modules/authorizations/store/actions/authorizations.actions';

import {
  upsertTemporaryLivingTrip,
  getTemporaryLivingAssignmentTrips,
  deleteTemporaryLivingTrip,
  getTemporaryLivingTripById
} from 'modules/authorizations/authorizations.actions';
import { DELETE_TEMP_LIVING_TRIP_FAILURE, UPSERT_TEMP_LIVING_TRIP_FAILURE } from 'modules/authorizations/types';

import {
  getTemporaryLivingAssignments,
  postTemporaryLivingAssignments,
  updateTemporaryLivingAssignments
} from 'modules/authorizations/store/actions/temporaryLiving.actions';

import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { showToast } from 'modules/layout/layout.actions';

import {
  POST_TEMPORARY_LIVING_ASSIGNMENT_FAILURE,
  GET_TEMPORARY_LIVING_ASSIGNMENT_FAILURE
} from 'modules/authorizations/store/types/temporaryLivingTypes';

import Spinner from 'modules/common/spinner.component';
import ServiceTriggeredComment from '../commentsAndNotes/serviceTriggeredComment.component';
import SlidingCommentsAndNotes from '../commentsAndNotes/commentsAndNotesSlidingPanel.component';

import PropertyCard from './tempLivingProperty.component';
import PreferencesCard from './tempLivingPreferences.component';
import MoveInOutCard from './tempLivingMoveInOut.component';

import { Button, Dialog, DialogActions, Grid, FormControl, InputLabel, MenuItem, Paper, Select, Typography } from '@mui/material';

import classNames from 'classnames';
import { DRAWER_WIDTH_CLOSED, DRAWER_WIDTH_CLOSED_XS, DRAWER_WIDTH_OPEN } from 'styles/theme';
import TempLivingTripSummaryComponent from './tempLivingTripSummary.component';
// import ServiceStatusStepper from '../serviceStatus.component';
import { ZERO_GUID } from '../destinationServices/destinationServicesDetailsEditableCard.component';
import { isIdEqual } from 'modules/enumerations/enumerationHelpers';
import { formatTripAddress, formatTripLocation } from 'modules/authorizations/utils';
import { UPDATE_TEMPORARY_LIVING_ASSIGNMENT_FAILURE } from 'modules/authorizations/types';
import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import { SERVICE_IDS } from 'modules/enumerations/enumerationIds';
import CreateTripCard from 'modules/common/createAuthTripModal.component';
import StatusMenu from 'modules/common/statusMenu.component';
import { getServiceStatusDates } from 'modules/authorizations/store/actions/authorizations.actions';
import AuthServiceGlobalEmailCardComponent from 'modules/emailTemplates/authEmailTemplates/authServiceGlobalEmailCard.component';
import AuthServiceCancellationToggleButton from 'modules/common/authServiceCancellationToggleButton.component';
import AuthServiceHoldToggleButton from 'modules/common/authServiceHoldToggleButton.component';
import { getUsStateOptions } from './utils';

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  container: {
    height: 'auto',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    whiteSpace: 'nowrap',
    width: `calc(100% - ${DRAWER_WIDTH_CLOSED_XS}px)`,
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${DRAWER_WIDTH_CLOSED}px)`
    }
  },
  drawerOpen: {
    width: `calc(100% - ${DRAWER_WIDTH_OPEN})`
  },
  headerFixed: {
    zIndex: 4
  },
  tabFixed: {
    paddingTop: '100px',
    zIndex: 3
  },
  previewTabFixed: {
    paddingTop: '10px',
    zIndex: 3
  },
  estimateHeaderFixed: {
    paddingTop: '150px',
    zIndex: 2
  },
  previewEstimateHeaderFixed: {
    paddingTop: '15px',
    zIndex: 3
  }
});

const TempLiving = props => {
  const {
    details,
    location,
    shouldShowSideDrawer,
    authId,
    isReadOnly,
    enumerations,
    temporaryLivingAssignments,
    emailTemplates,
    history,
    allVendorOptions,
    clientInfo
  } = props;

  const [statuses, setStatuses] = useState(
    details?.serviceStatusDates ? details.serviceStatusDates.filter(s => s.serviceType === 'Temp Living') : []
  );
  //const vendorsPreferredVendorSorted = CreateVendorRelationshipList(allVendorOptions, clientInfo?.clientDetails.clientVendorRelationships);
  const getStatuses = async () => {
    const resp = await props.getServiceStatusDates(authId);
    if (resp && Array.isArray(resp.response)) {
      setStatuses(resp.response.filter(s => s.serviceType === 'Temp Living'));
      return;
    }

    if (Array.isArray(details?.serviceStatusDates)) {
      setStatuses(details.serviceStatusDates.filter(s => s.serviceType === 'Temp Living'));
    }
  };
  const [assignments, setAssignments] = useState(temporaryLivingAssignments || []);
  useEffect(() => {
    setAssignments(temporaryLivingAssignments || []);
  }, [temporaryLivingAssignments]);

  const validTemplates = emailTemplates.filter(t => t.serviceId === SERVICE_IDS.TEMP_LIVING_SERVICE_ID);

  const [currentAssignmentId, setCurrentAssignmentId] = useState(
    assignments && assignments.length > 0 ? assignments[assignments.length - 1].temporaryLivingAssignmentId : null
  );
  const [currentAssignment, setCurrentAssignment] = useState(
    assignments && currentAssignmentId ? assignments.find(t => t.temporaryLivingAssignmentId === currentAssignmentId) : null
  );

  const [currentStatusId, setCurrentStatusId] = useState(
    currentAssignment && currentAssignment?.temporaryLivingAssignment ? currentAssignment?.temporaryLivingAssignment?.statusId : ZERO_GUID
  );

  useEffect(() => {
    setCurrentStatusId(currentAssignment?.temporaryLivingAssignment?.statusId ?? ZERO_GUID);
  }, [currentAssignment]);

  useEffect(() => {
    getStatuses();
  }, [authId, currentAssignmentId, currentStatusId]);

  useEffect(() => {
    if (Array.isArray(details?.serviceStatusDates)) {
      setStatuses(details.serviceStatusDates.filter(s => s.serviceType === 'Temp Living'));
    }
  }, [details?.serviceStatusDates]);

  const assignmentTypes =
    enumerations && enumerations.assignmentTypes && enumerations.assignmentTypes.length > 0
      ? enumerations.assignmentTypes.filter(s => s.isActive === true)
      : [{ id: ZERO_GUID, title: '' }];

  const provinces = getUsStateOptions(enumerations?.provinces);

  const serviceStatuses =
    enumerations && enumerations.temporaryLivingStatuses && Array.isArray(enumerations.temporaryLivingStatuses)
      ? enumerations.temporaryLivingStatuses.filter(s => s.isActive)
      : [{ id: ZERO_GUID, title: '' }];

  const moveTypes =
    enumerations && enumerations.moveTypes && Array.isArray(enumerations.moveTypes)
      ? enumerations.moveTypes.filter(s => s.isActive)
      : [{ id: ZERO_GUID, title: '' }];

  const selectedMoveTypeTitle = details?.authorizationDetails?.moveTypeId
    ? moveTypes.find(mt => mt.id === details.authorizationDetails.moveTypeId)?.title
    : '';

  const selectedPolicyTitle =
    clientInfo?.clientDetails?.clientRelocationPolicies && details?.authorizationDetails?.relocationPolicyId
      ? clientInfo.clientDetails.clientRelocationPolicies.find(
        crp => crp.policy.relocationPolicyId === details.authorizationDetails.relocationPolicyId
      )?.policy?.policyDescription
      : '';

  const authCommentServiceTypes =
    enumerations && enumerations.authCommentService && enumerations.authCommentService.length > 0
      ? enumerations.authCommentService.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const authCommentRegardingTypes =
    enumerations && enumerations.authCommentRegarding && enumerations.authCommentRegarding.length > 0
      ? enumerations.authCommentRegarding.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const [showAddAssignment, setShowAddAssignment] = useState(false);
  const [newAssignmentType, setNewAssignmentType] = useState(ZERO_GUID);
  const [newAssignmentState, setNewAssignmentState] = useState(ZERO_GUID);

  const [isLoadingAssignment, setIsLoadingAssignment] = useState(false);
  const [isLoadingAssignmentModal, setIsLoadingAssignmentModal] = useState(false);
  const [currentTripId, setCurrentTripId] = useState(
    currentAssignment?.trips && currentAssignment?.trips > 0 ? currentAssignment?.trips[0].tripId : null
  );

  // const trip = currentAssignment?.trips ? currentAssignment?.trips.find(s => s.tripId === currentTripId) : null;

  const addressOptions =
    details?.addresses && details?.addresses.length > 0
      ? details?.addresses.map(a => {
        const addressLabel = formatTripAddress(a, enumerations?.provinces, enumerations?.countries);
        return { ...a, id: a.addressId, title: addressLabel, description: addressLabel };
      })
      : [];

  const selectableAddressOptions = addressOptions.filter(s => s.excludeAddressFromSelection === false);

  const formatTripListAddress = address => formatTripLocation(address, enumerations?.provinces, enumerations?.countries);

  const [showTriggeredComment, setShowTriggeredComment] = useState(false);
  const [showComment, setShowComment] = useState(false);

  // The service is canceled or put on hold as a whole. Both dates are kept on the assignments, and saving one assignment
  // carries them to the rest.
  const isCanceled = assignments.some(a => a?.temporaryLivingAssignment?.canceledDate);
  const isOnHold = assignments.some(a => a?.temporaryLivingAssignment?.onHoldDate);

  const disableEdit = isCanceled || isOnHold;

  useEffect(() => {
    if (!assignments || assignments.length === 0 || !Array.isArray(assignments)) return;

    const exists = assignments.some(a => a.temporaryLivingAssignmentId === currentAssignmentId);
    if (!currentAssignmentId || !exists) {
      const last = assignments[assignments.length - 1];
      setCurrentAssignmentId(last.temporaryLivingAssignmentId);
    }
    if (currentAssignmentId) {
      getAssignmentData();
    }
  }, [assignments, currentAssignmentId]);

  const toIntOrNull = val => {
    if (val === null || val === undefined) return null;
    try {
      return val;
    } catch {
      return null;
    }
  };

  const createAssignment = async () => {
    setIsLoadingAssignmentModal(true);

    const tlRequest = {
      authorizationFileId: authId,
      bookingSourceId: ZERO_GUID,
      complexName: '',
      confirmBookingSourceId: ZERO_GUID,
      costCap: null,
      costCapOptionId: ZERO_GUID,
      dailyCostCap: null,
      dailyRate: null,
      daysAllowed: null,
      daysRequested: null,
      estimatedMoveIn: null,
      estimatedMoveOut: null,
      exceptionDays: null,
      initializationDate: null,
      movedInDate: null,
      movedOutDate: null,
      noticeDueDate: null,
      noticeGiven: null,
      noticeToVacateId: ZERO_GUID,
      numberOfBedrooms: null,
      propertyAddressId: 0,
      specialNeeds: '',
      statusId: ZERO_GUID,
      tempLivingCity: '',
      tempLivingStateId: newAssignmentState || ZERO_GUID,
      unitTypeId: ZERO_GUID,
      assignmentType: newAssignmentType || ZERO_GUID,
      requestedDate: null,
      optionsSentDate: null,
      confirmedDate: null,
      canceledDate: null,
      onHoldDate: null,
      temporaryLivingAssignmentId: null
    };

    const request = {
      temporaryLivingAssignment: tlRequest,
      temporaryLivingAssignmentId: 0,
      propertyAddress: null,
      pets: [],
      familyMembers: []
    };

    const resp = await props.postTemporaryLivingAssignments(authId, request);

    if (resp.type === POST_TEMPORARY_LIVING_ASSIGNMENT_FAILURE) {
      props.showToast('Failed to update the temp living assignment info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoadingAssignmentModal(false);
      return;
    }

    const newId = resp.response?.temporaryLivingAssignmentId ?? null;
    if (newId) {
      setCurrentAssignmentId(newId);
      setCurrentAssignment(resp.response);
    }

    const allAssignmentsResp = await props.getTemporaryLivingAssignments(authId);
    if (allAssignmentsResp.type === GET_TEMPORARY_LIVING_ASSIGNMENT_FAILURE) {
      props.showToast('Failed to fetch the temp living assignment info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    } else {
      const all = Array.isArray(allAssignmentsResp.response) ? allAssignmentsResp.response : [];
      const withValidIds = all.map(a => ({ a, key: toIntOrNull(a.temporaryLivingAssignmentId) })).filter(x => x.key !== null);

      if (withValidIds.length > 0) {
        const newest = withValidIds.reduce((max, curr) => (curr.key > max.key ? curr : max)).a;

        setCurrentAssignmentId(newest.temporaryLivingAssignmentId);
        setCurrentAssignment(newest);
      }
      props.showToast('Assignment created successfully.', { userMustDismiss: false, severity: 'success' });
      setShowAddAssignment(false);
    }

    setIsLoadingAssignmentModal(false);
  };

  const createTrip = async values => {
    let newValues = {};

    newValues.tripName = values.tripName ? values.tripName : '';
    newValues.tripCategoryId = 'aab171b4-a184-4c91-841f-30702fbaff99';
    newValues.familyAttending = values.familyAttending ? values.familyAttending.join(',') : values.familyAttending;
    newValues.typeOfTrip = values.typeOfTrip ? values.typeOfTrip : '';
    newValues.tripStartDate = values.tripStartDate ? values.tripStartDate : new Date();
    newValues.tripEndDate = values.tripEndDate ? values.tripEndDate : new Date();
    newValues.departureDate = values.departureDate ? values.departureDate : new Date();
    newValues.arrivalDate = values.arrivalDate ? values.arrivalDate : new Date();
    newValues.tripDuration = values.tripDuration ? values.tripDuration : 0;
    newValues.departureAddressId = values.departureAddressId ? values.departureAddressId : 0;
    newValues.destinationAddressId = values.destinationAddressId ? values.destinationAddressId : 0;
    newValues.specialNeeds = values.specialNeeds ? values.specialNeeds : '';
    newValues.notes = values.notes ? values.notes : '';

    if (values.hasBookingDetails && values.hasBookingDetails === 'Self Booked') {
      newValues.hasBookingDetails = false;
    } else {
      newValues.hasBookingDetails = true;
    }

    newValues.airTransport = values.airTransport;
    newValues.airTransportDepartureDate = values.airTransportDepartureDate;
    newValues.airTransportArrivalDate = values.airTransportArrivalDate;
    newValues.airTransportReturnDepartureDate = values.airTransportReturnDepartureDate;
    newValues.airTransportReturnArrivalDate = values.airTransportReturnArrivalDate;

    newValues.hotelBooking = values.hotelBooking;
    newValues.hotelName = values.hotelName;
    newValues.hotelAddressId = values.hotelAddressId;
    newValues.hotelCheckInDate = values.hotelCheckInDate;
    newValues.hotelCheckOutDate = values.hotelCheckOutDate;
    newValues.hotelDurationOfStay = values.hotelDurationOfStay;

    newValues.rentalCarBooking = values.rentalCarBooking;
    newValues.rentalCarClassId = values.rentalCarClassId;
    newValues.otherRentalCar = values.otherRentalCar;
    newValues.rentalCarStartDate = values.rentalCarStartDate;
    newValues.rentalCarEndDate = values.rentalCarEndDate;
    newValues.rentalCarDuration = values.rentalCarDuration;
    newValues.addedBy = values.addedBy ? values.addedBy : 0;
    newValues.addedOn = values.addedOn ? values.addedOn : new Date();
    newValues.modifiedBy = 0;
    newValues.modifiedOn = new Date();

    if (values.hasBookingDetails && values.hasBookingDetails === 'Self Booked') {
      newValues.hasBookingDetails = false;
    } else {
      newValues.hasBookingDetails = true;
    }

    const resp = await props.upsertTemporaryLivingTrip(currentAssignmentId, newValues);

    if (resp.type === UPSERT_TEMP_LIVING_TRIP_FAILURE) {
      props.showToast('Failed to update the temp living trips info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    } else {
      const allAssignmentsResp = await props.getTemporaryLivingAssignments(authId);
      if (allAssignmentsResp.type === GET_TEMPORARY_LIVING_ASSIGNMENT_FAILURE) {
        props.showToast('Failed to fetch temp living assignments, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      } else {
        props.showToast('New Temp Living Trip created successfully.', { userMustDismiss: false, severity: 'success' });
        const currentTrips = allAssignmentsResp.response.find(assignment => assignment.temporaryLivingAssignmentId === currentAssignmentId)
          .trips;
        setCurrentTripId(currentTrips[currentTrips.length - 1].tripId);
      }
    }
  };

  const deleteTrip = async () => {
    const deleteTripResp = await props.deleteTemporaryLivingTrip(currentTripId);
    if (deleteTripResp.type === DELETE_TEMP_LIVING_TRIP_FAILURE) {
      props.showToast('Failed to delete the current temp living trip info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    } else {
      props.showToast('Trip deleted successfully.', { userMustDismiss: false, severity: 'success' });
      setCurrentTripId(details?.authDetails?.trips.filter(t => t.tripCategory === 'Homefinding')[0].tripId);
      const allAssignmentsResp = await props.getTemporaryLivingAssignments(authId);
      if (allAssignmentsResp.type === GET_TEMPORARY_LIVING_ASSIGNMENT_FAILURE) {
        props.showToast('Failed to get the temp living trips info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }
    }
  };

  // useEffect(() => {
  //   if (currentTripId) {
  //     getTripData();
  //   }
  // }, [currentTripId]);

  const getAssignmentData = async () => {
    setIsLoadingAssignment(true);
    setCurrentAssignment(assignments?.find(t => t.temporaryLivingAssignmentId === currentAssignmentId));
    setIsLoadingAssignment(false);
  };

  useEffect(() => {
    if (currentAssignmentId) {
      getAssignmentData();
    }
  }, [currentAssignmentId]);

  const buildAssignmentDisplayName = (assignment, enumerations) => {
    if (!assignment || !enumerations) return '';
    const assignmentInfo = assignment.temporaryLivingAssignment;

    const assignmentTypeId = assignmentInfo.assignmentType ?? ZERO_GUID;
    const stateId = assignmentInfo.tempLivingStateId ?? ZERO_GUID;

    const assignmentType = (enumerations.assignmentTypes ?? []).find(e => e.id === assignmentTypeId);
    const state = (enumerations.provinces ?? []).find(e => e.id === stateId);

    const assignmentTypeTitle = assignmentType?.title || 'Unknown Type';
    const stateTitle = state?.title || 'Unknown State';

    return `${assignmentTypeTitle} - ${stateTitle}`;
  };

  const updateServiceStatusDates = async statusDates => {
    if (!currentAssignment?.temporaryLivingAssignment) return;

    setIsLoadingAssignmentModal(true);
    const request = {
      ...currentAssignment,
      temporaryLivingAssignment: { ...currentAssignment.temporaryLivingAssignment, ...statusDates }
    };

    const resp = await props.updateTemporaryLivingAssignments(authId, currentAssignmentId, request);
    if (resp.type === UPDATE_TEMPORARY_LIVING_ASSIGNMENT_FAILURE) {
      props.showToast('Failed to update the assignment info, please try again.', {
        severity: TOAST_MESSAGE_SEVERITY_ERROR
      });
      setIsLoadingAssignmentModal(false);
      return;
    }

    await props.getTemporaryLivingAssignments(authId);
    await props.getServiceStatusDates(authId);
    setIsLoadingAssignmentModal(false);
  };

  // The service's own date, taken from whichever assignment has it, since the selected assignment is what gets saved and
  // carried to the rest.
  const getServiceStatusDate = dateName =>
    assignments.find(a => a?.temporaryLivingAssignment?.[dateName])?.temporaryLivingAssignment?.[dateName] ?? null;

  // Canceling and reactivating leave the hold alone, so a service that was on hold when it was canceled comes back on hold.
  const onHandleCancelService = () =>
    updateServiceStatusDates({ canceledDate: new Date().toISOString(), onHoldDate: getServiceStatusDate('onHoldDate') });

  const onHandleReactivateService = () => updateServiceStatusDates({ canceledDate: null, onHoldDate: getServiceStatusDate('onHoldDate') });

  const onHandleSetOnHold = () =>
    updateServiceStatusDates({ onHoldDate: new Date().toISOString(), canceledDate: getServiceStatusDate('canceledDate') });

  const onHandleTakeOffHold = () => updateServiceStatusDates({ onHoldDate: null, canceledDate: getServiceStatusDate('canceledDate') });

  const onHandleReset = async () => {
    setCurrentStatusId(enumerations.allEnums.temporaryLivingStatuses.find(s => s.title === 'Initiated')?.id ?? ZERO_GUID);
    setIsLoadingAssignmentModal(true);
    const tlInfo = currentAssignment.temporaryLivingAssignment;

    const tlRequest = {
      ...tlInfo,
      canceledDate: null,
      onHoldDate: null,
      ConfirmedDate: null,
      optionsSentDate: null,
      requestedDate: null,
      movedInDate: null,
      movedOutDate: null,
      noticeGiven: null,
      statusId: enumerations.allEnums.temporaryLivingStatuses.find(s => s.title === 'Initiated')?.id ?? ZERO_GUID
    };

    const request = {
      ...currentAssignment,
      temporaryLivingAssignment: tlRequest
    };

    const resp = await props.updateTemporaryLivingAssignments(authId, currentAssignmentId, request);
    if (resp.type === UPDATE_TEMPORARY_LIVING_ASSIGNMENT_FAILURE) {
      props.showToast('Failed to update the assignment info, please try again.', {
        severity: TOAST_MESSAGE_SEVERITY_ERROR
      });
      setIsLoadingAssignmentModal(false);
      return;
    }

    await props.getTemporaryLivingAssignments(authId);
    await props.getServiceStatusDates(authId);
    setIsLoadingAssignmentModal(false);
  };

  const [openStatusMenu, setOpenStatusMenu] = useState(false);

  // Being on hold is not one of the assignment's statuses, so it is shown over the saved status rather than stored in it.
  const getCurrentStatusTitle = () => {
    if (isCanceled) return 'Canceled';
    if (isOnHold) return 'On Hold';
    return serviceStatuses.find(s => isIdEqual(s.id, currentStatusId))?.title;
  };
console.log(currentAssignment)

  const tempLivingStatusOrder = [
    {
      title: 'Initiated',
      id:
        enumerations && enumerations.temporaryLivingStatuses && enumerations.temporaryLivingStatuses.length > 0
          ? enumerations.temporaryLivingStatuses.find(s => s.title === 'Initiated')?.id
          : '',
      isActive: true,
      date: details?.services?.find(s => s.authorizationFileServiceTypeId === 'a6431f21-754e-4546-8511-12e74170f139')?.addedOn ?? null
    },
    {
      title: 'Requested',
      id:
        enumerations && enumerations.temporaryLivingStatuses && enumerations.temporaryLivingStatuses.length > 0
          ? enumerations.temporaryLivingStatuses.find(s => s.title === 'Requested')?.id
          : '',
      isActive: true,
      date: currentAssignment?.temporaryLivingAssignment?.requestedDate ?? null
    },
    {
      title: 'Options Sent',
      id:
        enumerations && enumerations.temporaryLivingStatuses && enumerations.temporaryLivingStatuses.length > 0
          ? enumerations.temporaryLivingStatuses.find(s => s.title === 'Options Sent')?.id
          : '',
      isActive: true,
      date: currentAssignment?.temporaryLivingAssignment?.optionsSentDate ?? null
    },
    {
      title: 'Confirmed',
      id:
        enumerations && enumerations.temporaryLivingStatuses && enumerations.temporaryLivingStatuses.length > 0
          ? enumerations.temporaryLivingStatuses.find(s => s.title === 'Confirmed')?.id
          : '',
      isActive: true,
      date: currentAssignment?.temporaryLivingAssignment?.confirmedDate ?? null
    },
    {
      title: 'Moved In',
      id:
        enumerations && enumerations.temporaryLivingStatuses && enumerations.temporaryLivingStatuses.length > 0
          ? enumerations.temporaryLivingStatuses.find(s => s.title === 'Moved In')?.id
          : '',
      isActive: true,
      date: currentAssignment?.temporaryLivingAssignment?.movedInDate ?? null
    },
    {
      title: 'Notice to Vacate Sent',
      id:
        enumerations && enumerations.temporaryLivingStatuses && enumerations.temporaryLivingStatuses.length > 0
          ? enumerations.temporaryLivingStatuses.find(s => s.title === 'Notice to Vacate Sent')?.id
          : '',
      isActive: true,
      date: currentAssignment?.temporaryLivingAssignment?.noticeGiven ?? null
    },
    {
      title: 'Moved Out',
      id:
        enumerations && enumerations.temporaryLivingStatuses && enumerations.temporaryLivingStatuses.length > 0
          ? enumerations.temporaryLivingStatuses.find(s => s.title === 'Moved Out')?.id
          : '',
      isActive: true,
      date: currentAssignment?.temporaryLivingAssignment?.movedOutDate ?? null
    },
    {
      title: 'Canceled',
      id:
        enumerations && enumerations.temporaryLivingStatuses && enumerations.temporaryLivingStatuses.length > 0
          ? enumerations.temporaryLivingStatuses.find(s => s.title === 'Canceled')?.id
          : '',
      isActive: isCanceled,
      date: currentAssignment?.temporaryLivingAssignment?.canceledDate ?? null
    },
    {
      title: 'On Hold',
      id:
        enumerations && enumerations.globalServiceStatusTypes && enumerations.globalServiceStatusTypes.length > 0
          ? enumerations.globalServiceStatusTypes.find(s => s.title === 'On Hold')?.id
          : '',
      isActive: !isCanceled && isOnHold,
      date: currentAssignment?.temporaryLivingAssignment?.onHoldDate ?? null
    },
    {
      title: 'Completed',
      id:
        enumerations && enumerations.temporaryLivingStatuses && enumerations.temporaryLivingStatuses.length > 0
          ? enumerations.temporaryLivingStatuses.find(s => s.title === 'Completed')?.id
          : '',
      isActive: false,
      date: currentAssignment?.temporaryLivingAssignment?.completedDate ?? null
    }
  ];

  return (
    <>
      <Box>
        {showComment && (
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1200,
              pointerEvents: 'none'
            }}
          />
        )}
        {location && (location.pathname.includes('expenses') || isReadOnly) && (
          <>
            <Paper
              square
              className={classNames({
                'position-fixed': !isReadOnly,
                [props.classes.headerFixed]: !isReadOnly,
                [props.classes.container]: true,
                [props.classes.drawerOpen]: shouldShowSideDrawer
              })}
              sx={isReadOnly ? { paddingTop: '5px', zIndex: 4, position: 'relative' } : {}}
            >
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
                <Box>
                  <div className={props.classes.mb2}>
                    <Typography variant="subtitle2">Assignment</Typography>
                  </div>
                  <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <Select
                      labelId={'assignmentSelect'}
                      key={'assignmentSelect'}
                      label={''}
                      name={'assignmentSelect'}
                      value={currentAssignmentId}
                      sx={{ maxWidth: '360px', minWidth: '180px' }}
                      onChange={e => setCurrentAssignmentId(e.target.value)}
                    >
                      {assignments &&
                        assignments.map(opt => {
                          const id = opt.temporaryLivingId ?? opt.temporaryLivingAssignmentId;
                          return (
                            <MenuItem key={id} value={id}>
                              {buildAssignmentDisplayName(opt, enumerations)}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '20px' }}>
                  <StatusMenu
                    anchorEl={openStatusMenu}
                    onClose={() => setOpenStatusMenu(false)}
                    currentStatus={getCurrentStatusTitle()}
                    statusHeader="Assignment Status"
                    statusList={tempLivingStatusOrder}
                    statusDates={statuses}
                    classes={props.classes}
                    serviceInitiationDate={currentAssignment?.temporaryLivingAssignment?.initiationDate}
                  />
                  <Box>
                    <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                        Move Type
                      </Typography>
                    </Box>
                    <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                      <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                        {selectedMoveTypeTitle || <div>&mdash;</div>}
                      </Typography>
                    </Box>
                  </Box>
                  <Box>
                    <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                        Policy
                      </Typography>
                    </Box>
                    <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                      <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                        {selectedPolicyTitle || <div>&mdash;</div>}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '20px' }}></Box>
              </Box>
            </Paper>
            {currentAssignmentId == null && (
              <Box sx={{ padding: '20px', paddingTop: '165px', fontSize: '20px' }}>
                <b>No assignment selected. Create a new assignment above to get started.</b>
              </Box>
            )}
            {currentAssignmentId != null && (
              <Box sx={{ padding: '20px', paddingTop: '15px' }}>
                <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
                  <Grid item xs={12} xl={8} rowSpacing={2}>
                    <PreferencesCard
                      details={details}
                      tempLivingAssignment={currentAssignment}
                      hideEdit={true}
                      authId={authId}
                      location={location}
                      familyMembers={details?.familyMembers}
                      pets={details?.pets}
                      enumerations={enumerations}
                      disableEdit={true}
                      setStatusDates={setStatuses}
                    />
                    <Box sx={{ paddingTop: '16px' }}>
                      <PropertyCard
                        details={details}
                        tempLivingAssignment={currentAssignment}
                        hideEdit={true}
                        authId={authId}
                        location={location}
                        enumerations={enumerations}
                        disableEdit={true}
                      />
                    </Box>
                    <Box sx={{ paddingTop: '16px' }}>
                      <CreateTripCard
                        onSubmit={createTrip}
                        onDelete={deleteTrip}
                        familyMembers={details?.familyMembers}
                        trips={currentAssignment?.trips}
                        location={location}
                        enumerations={props.enumerations}
                        addresses={selectableAddressOptions}
                        showToast={showToast}
                        classes={props.classes}
                        currentTripId={currentTripId}
                        setCurrentTripId={setCurrentTripId}
                        formatTripListAddress={formatTripListAddress}
                        isReadOnly={true}
                        defaultCategory={'aab171b4-a184-4c91-841f-30702fbaff99'}
                      />
                    </Box>
                    {currentTripId && currentAssignment?.trips && (
                      <Grid item>
                        <TempLivingTripSummaryComponent
                          trip={currentAssignment?.trips.find(t => t.tripId === currentTripId)}
                          familyMembers={details?.familyMembers}
                          travelRequests={currentAssignment?.trips}
                          hideEdit={true}
                          id={authId}
                          addresses={selectableAddressOptions}
                          enumerations={enumerations}
                          serviceId={currentAssignmentId}
                        />
                      </Grid>
                    )}
                  </Grid>
                  <Grid item xs={12} xl={4} rowSpacing={2}>
                    <AuthServiceGlobalEmailCardComponent
                      key={`temp-living-email-preview-${currentAssignmentId}`}
                      authId={authId}
                      communication={details.authorizationDetails}
                      emailTemplates={emailTemplates}
                      serviceId={SERVICE_IDS.TEMP_LIVING_SERVICE_ID}
                      authCommentServicesEnum={authCommentServiceTypes}
                      authCommentRegardingEnum={authCommentRegardingTypes}
                      authSentTemplates={details?.sentEmailTemplates}
                      history={history}
                      selectedAuthServiceId={currentAssignmentId}
                      allVendorOptions={allVendorOptions}
                      selectedSegmentServiceId={currentAssignmentId}
                      serviceTemplates={validTemplates}
                    />
                    <Box sx={{ paddingTop: '16px' }}>
                      <MoveInOutCard
                        details={details}
                        tempLivingAssignment={currentAssignment}
                        hideEdit={true}
                        authId={authId}
                        location={location}
                        enumerations={enumerations}
                        disableEdit={true}
                        setStatusDates={setStatuses}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            )}
          </>
        )}
        {location && !location.pathname.includes('expenses') && !isReadOnly && (
          <>
            <Paper
              square
              className={classNames('position-fixed', props.classes.headerFixed, props.classes.container, {
                [props.classes.drawerOpen]: shouldShowSideDrawer
              })}
            >
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
                <Box>
                  <div className={props.classes.mb2}>
                    <Typography variant="subtitle2">Assignment</Typography>
                  </div>
                  <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <Select
                      labelId={'assignmentSelect'}
                      key={'assignmentSelect'}
                      label={''}
                      name={'assignmentSelect'}
                      value={currentAssignmentId}
                      sx={{ maxWidth: '360px', minWidth: '180px' }}
                      onChange={e => setCurrentAssignmentId(e.target.value)}
                      disabled={isLoadingAssignmentModal}
                    >
                      {assignments &&
                        assignments.map(opt => {
                          const id = opt.temporaryLivingAssignmentId;
                          return (
                            <MenuItem key={id} value={id}>
                              {buildAssignmentDisplayName(opt, enumerations)}
                            </MenuItem>
                          );
                        })}
                    </Select>
                    <Button
                      color="secondary"
                      type="submit"
                      variant="contained"
                      sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                      onClick={() => setShowAddAssignment(true)}
                      disabled={isLoadingAssignmentModal || isCanceled || isOnHold}
                    >
                      New Assignment
                    </Button>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '20px' }}>
                  <StatusMenu
                    anchorEl={openStatusMenu}
                    onClose={() => setOpenStatusMenu(false)}
                    currentStatus={getCurrentStatusTitle()}
                    statusHeader="Assignment Status"
                    statusList={tempLivingStatusOrder}
                    statusDates={statuses}
                    classes={props.classes}
                    serviceInitiationDate={currentAssignment?.temporaryLivingAssignment?.initiationDate}
                  />
                  <Box>
                    <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                        Move Type
                      </Typography>
                    </Box>
                    <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                      <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                        {selectedMoveTypeTitle || <div>&mdash;</div>}
                      </Typography>
                    </Box>
                  </Box>
                  <Box>
                    <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                        Policy
                      </Typography>
                    </Box>
                    <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                      <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                        {selectedPolicyTitle || <div>&mdash;</div>}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '20px' }}>
                  <Button
                    color="secondary"
                    variant="contained"
                    sx={{
                      maxHeight: '40px',
                      marginLeft: '12px',
                      marginTop: '8px',
                      backgroundColor: '#f01dc9ff',
                      '&:hover': { backgroundColor: '#ba007fff' }
                    }}
                    onClick={onHandleReset}
                    disabled={isLoadingAssignmentModal}
                  >
                    Reset (Testing)
                  </Button>
                  <AuthServiceCancellationToggleButton
                    isCancelled={isCanceled}
                    serviceName="Temporary Living"
                    disabled={!currentAssignmentId || isLoadingAssignmentModal}
                    sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                    onServiceCancelled={onHandleCancelService}
                    onServiceReactivated={onHandleReactivateService}
                  />
                  {!isCanceled && (
                    <AuthServiceHoldToggleButton
                      isOnHold={isOnHold}
                      disabled={!currentAssignmentId || isLoadingAssignmentModal}
                      sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                      onSetOnHold={onHandleSetOnHold}
                      onTakeOffHold={onHandleTakeOffHold}
                    />
                  )}
                  {/* <Button
                    color="secondary"
                    variant="contained"
                    sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                    onClick={completeService}
                  >
                    Complete Service
                  </Button> */}
                  <Button
                    onClick={() => setShowComment(true)}
                    variant="contained"
                    sx={{
                      maxHeight: '40px',
                      marginLeft: '12px',
                      marginTop: '8px',
                      backgroundColor: '#41B7C0',
                      color: 'white',
                      '&:hover': { backgroundColor: '#3d959c' }
                    }}
                    disabled={isLoadingAssignmentModal}
                  >
                    Comments
                  </Button>
                </Box>
              </Box>
            </Paper>
            {isLoadingAssignmentModal && (
              <Box sx={{ padding: '20px', paddingTop: '165px', fontSize: '20px' }}>
                <FullscreenSpinner />
              </Box>
            )}
            {!isLoadingAssignmentModal && currentAssignmentId == null && (
              <Box sx={{ padding: '20px', paddingTop: '165px', fontSize: '20px' }}>
                <b>No assignment selected. Create a new assignment above to get started.</b>
              </Box>
            )}
            {!isLoadingAssignmentModal && currentAssignmentId != null && (
              <Box sx={{ padding: '20px', paddingTop: '125px' }}>
                {/* <ServiceStatusStepper currentStatusId={currentStatusId} serviceStatuses={serviceStatuses} /> */}
                <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
                  <Grid item xs={12} xl={8} rowSpacing={2}>
                    <PreferencesCard
                      details={details}
                      tempLivingAssignment={currentAssignment}
                      hideEdit={false}
                      authId={authId}
                      location={location}
                      familyMembers={details?.familyMembers}
                      pets={details?.pets}
                      enumerations={enumerations}
                      disableEdit={disableEdit}
                      setStatusDates={setStatuses}
                    />
                    <Box sx={{ paddingTop: '16px' }}>
                      <PropertyCard
                        details={details}
                        tempLivingAssignment={currentAssignment}
                        hideEdit={false}
                        authId={authId}
                        location={location}
                        enumerations={enumerations}
                        disableEdit={disableEdit}
                      />
                    </Box>
                    <Box sx={{ paddingTop: '16px' }}>
                      <CreateTripCard
                        onSubmit={createTrip}
                        onDelete={deleteTrip}
                        familyMembers={details?.familyMembers}
                        trips={currentAssignment?.trips}
                        location={location}
                        enumerations={props.enumerations}
                        addresses={selectableAddressOptions}
                        showToast={showToast}
                        classes={props.classes}
                        currentTripId={currentTripId}
                        setCurrentTripId={setCurrentTripId}
                        formatTripListAddress={formatTripListAddress}
                        isReadOnly={location.pathname.includes('expenses') || isReadOnly || disableEdit}
                        defaultCategory={'aab171b4-a184-4c91-841f-30702fbaff99'}
                      />
                    </Box>
                    {currentTripId && currentAssignment?.trips && (
                      <>
                        <Grid item>
                          <TempLivingTripSummaryComponent
                            trip={currentAssignment?.trips.find(t => t.tripId === currentTripId)}
                            familyMembers={details?.familyMembers}
                            travelRequests={currentAssignment?.trips}
                            hideEdit={location.pathname.includes('expenses') || isReadOnly || disableEdit}
                            id={authId}
                            addresses={selectableAddressOptions}
                            enumerations={enumerations}
                            serviceId={currentAssignmentId}
                          />
                        </Grid>
                      </>
                    )}
                  </Grid>
                  <Grid item xs={12} xl={4} rowSpacing={2}>
                    <AuthServiceGlobalEmailCardComponent
                      key={`temp-living-email-${currentAssignmentId}`}
                      authId={authId}
                      communication={details.authorizationDetails}
                      emailTemplates={emailTemplates}
                      serviceId={SERVICE_IDS.TEMP_LIVING_SERVICE_ID}
                      authCommentServicesEnum={authCommentServiceTypes}
                      authCommentRegardingEnum={authCommentRegardingTypes}
                      authSentTemplates={details?.sentEmailTemplates}
                      history={history}
                      selectedAuthServiceId={currentAssignmentId}
                      // vendorOptions={allVendorOptions}
                      allVendorOptions={allVendorOptions}
                      selectedSegmentServiceId={currentAssignmentId}
                      serviceTemplates={validTemplates}
                    />
                    <Box sx={{ paddingTop: '16px' }}>
                      <MoveInOutCard
                        details={details}
                        tempLivingAssignment={currentAssignment}
                        hideEdit={false}
                        authId={authId}
                        location={location}
                        enumerations={enumerations}
                        disableEdit={disableEdit}
                        setStatusDates={setStatuses}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            )}
          </>
        )}
        <Dialog open={showAddAssignment} fullWidth={false} maxWidth={'lg'}>
          <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px' }}>
            <Box sx={{ marginRight: '20px' }}>
              <FormControl sx={{ marginTop: '6px' }}>
                <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'hhgType'}>
                  Assignment Type
                </InputLabel>
                <Select
                  labelId={'newAssignmentType'}
                  key={'newAssignmentType'}
                  label={'newAssignmentType'}
                  name={'newAssignmentType'}
                  required={true}
                  disabled={false}
                  value={newAssignmentType}
                  margin="dense"
                  variant="standard"
                  sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                  onChange={e => setNewAssignmentType(e.target.value)}
                >
                  {assignmentTypes.map(opt => (
                    <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }}>
                      {opt.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </Box>
            <Box sx={{ marginRight: '20px' }}>
              <FormControl sx={{ marginTop: '6px' }}>
                <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'newAssignmentState'}>
                  Assignment State
                </InputLabel>
                <Select
                  labelId={'newAssignmentState'}
                  key={'newAssignmentState'}
                  label={'Assignment State'}
                  name={'newAssignmentState'}
                  required={true}
                  disabled={false}
                  value={newAssignmentState}
                  margin="dense"
                  variant="standard"
                  sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                  onChange={e => setNewAssignmentState(e.target.value)}
                >
                  {provinces.map(opt => (
                    <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }}>
                      {opt.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>
          <DialogActions sx={{ p: '1.25rem' }}>
            {(isLoadingAssignmentModal || isLoadingAssignment) && <Spinner />}
            {!isLoadingAssignmentModal && !isLoadingAssignment && (
              <>
                <Button onClick={() => setShowAddAssignment(false)}>Cancel</Button>
                <Button
                  onClick={createAssignment}
                  color="primary"
                  type="submit"
                  variant="contained"
                  disabled={!(newAssignmentType !== ZERO_GUID && newAssignmentState !== ZERO_GUID)}
                >
                  Create Assignment
                </Button>
              </>
            )}
          </DialogActions>
        </Dialog>
      </Box>
      {showTriggeredComment && (
        <ServiceTriggeredComment
          authorizationId={authId}
          serviceOptionId={'c8aabef5-9434-4e8e-8a6b-4417747ecbed'}
          displayText={'Temporary Living - Service Completed Comment'}
          setShowTriggeredComment={setShowTriggeredComment}
        />
      )}
      {showComment && (
        <SlidingCommentsAndNotes
          authorizationId={authId}
          serviceOptionId={'c8aabef5-9434-4e8e-8a6b-4417747ecbed'}
          setShowComment={setShowComment}
          isOpen={true}
        />
      )}
    </>
  );
};

TempLiving.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    shouldShowSideDrawer: state.layout.shouldShowSideDrawer
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    getTemporaryLivingAssignments,
    postTemporaryLivingAssignments,
    upsertTemporaryLivingTrip,
    deleteTemporaryLivingTrip,
    getTemporaryLivingTripById,
    getTemporaryLivingAssignmentTrips,
    getAddress,
    deleteAuthTrip,
    showToast,
    updateTemporaryLivingAssignments,
    getServiceStatusDates
  })
)(TempLiving);
